/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { IPAddress } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { DrawerFooter } from '../../../commons/styles/layout';
import { API_MODULES, API_RUBUSMASTERS } from '../../../commons/api';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { UpdateMasters, CreateMasters, getAttributeFileDownloadName } from '../APICalls';
import {
  Form,
  Input,
  message,
  Button,
  Drawer,
  Upload,
  Tabs
} from 'antd';
import {
  SearchOutlined,
  EditOutlined,
  UploadOutlined,
  DownloadOutlined,
  PlusOutlined
} from '@ant-design/icons';
import translation from '../Utils/translation';
const { TabPane } = Tabs;
const APIList = {
  CreateAttributes: `${API_MODULES.AttributesCreate}`,
  UpdateAttributes: `${API_MODULES.AttributesUpdate}`
};

const Attributes = (props) => {
  const [formObject, setFormObject] = useState({});
  const [list, setList] = useState([]);
  const [visibleParent, setVisibleParent] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [fileDownloadName, setFileDownloadName] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  let searchInput = useRef(null);
  const hForm = useRef(null);

  useEffect(() => {
    _getList();
    getFileDownloadName();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    // Handle translation cache updates if needed
  }, [translationCache]);



  const _getList = () => {
    let path = '';
    if (props && props.type && props.type === 'deviceTypes') {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    } else {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/SubDeviceChildren/');
    }
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = '';
    url = `/api/rubusMaster/attributes/get?SiteId=${siteId}&DeviceType=${path[1]}`;

    let orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const _editRecord = (record) => {
    hForm.current && hForm.current.setFieldsValue(record);
    setVisibleParent(true);
    setFormObject(record);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />

        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const OpenDrawer = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        DeviceType: null,
        isEditableOnUpdate: null,
        mandatory: null,
        widget: null,
        API: null
      });
    let formObject = {
      Code: null,
      Name: null,
      DeviceType: null,
      isEditableOnUpdate: null,
      mandatory: null,
      widget: null,
      API: null
    };
    setVisibleParent(true);
    setFormObject(formObject);
  };

  const onClose = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        DeviceType: null,
        isEditableOnUpdate: null,
        mandatory: null,
        widget: null,
        API: null
      });
    setVisibleParent(false);
    setFormObject({});
  };



  const onFinish = async () => {
    let path = '';
    if (props && props.type && props.type === 'deviceTypes') {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    } else {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/SubDeviceChildren/');
    }
    hForm.current &&
      hForm.current
        .validateFields()
        .then(async (values) => {
          let payload = {
            ...values,
            DeviceType: path && Array.isArray(path) && path[1] ? path[1] : ''
          };
          if (formObject && formObject.Id) {
            let UpdateResponse = await UpdateMasters(
              APIList.UpdateAttributes,
              payload,
              formObject.Id
            );
            message.success(UpdateResponse && UpdateResponse.message);
          } else {
            let CreateResponse = await CreateMasters(APIList.CreateAttributes, payload);
            CreateResponse && message.success(CreateResponse && CreateResponse.message);
          }
          _getList();
          getFileDownloadName();
          hForm.current &&
            hForm.current.setFieldsValue({
              Code: null,
              Name: null,
              DeviceType: null,
              isEditableOnUpdate: null,
              mandatory: null,
              widget: null,
              API: null
            });
          setFormObject({});
          setVisibleParent(false);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const getFileDownloadName = async () => {
    let path = '';
    if (props && props.type && props.type === 'deviceTypes') {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    } else {
      path = window.location.pathname.split('/rubus/CustomerAssetDevice/SubDeviceChildren/');
    }
    let fileDownloadName = await getAttributeFileDownloadName(path[1]);
    setFileDownloadName(fileDownloadName && fileDownloadName.file ? fileDownloadName.file : '');
  };

  let colum = [
    { key: 'S No', value: 'S No' },
    { key: 'Attribute Code', value: 'Code' },
    { key: 'Attribute Name', value: 'Name' },
    { key: 'Mandatory', value: 'mandatory' },
    { key: 'Widget', value: 'widget' },
    { key: 'Is Editable OnUpdate', value: 'isEditableOnUpdate' }
  ];

  let columns =
    colum && Array.isArray(colum)
      ? colum
        .map((field) => {
          return {
            title: field.key,
            dataIndex: field.value,
            key: field.value,
            ...getColumnSearchProps(field.value)
          };
        })
      : [];

  let finalColumns = [
    ...columns,
    {
      title: translation(translationCache, 'Actions'),
      dataIndex: 'Actions',
      key: 'Actions',
      render: (_text, record) => (
        <span>
          <Button
            type='primary'
            icon={<EditOutlined />}
            onClick={() => _editRecord(record)}

          />
        </span>
      )
    }
  ];

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  let path = '';
  if (props && props.type && props.type === 'deviceTypes') {
    path = window.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
  } else {
    path = window.location.pathname.split('/rubus/CustomerAssetDevice/SubDeviceChildren/');
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'right', marginTop: '10px' }}>
        <Button type='primary' style={{ marginRight: '10px' }}>
          <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
            <DownloadOutlined style={{ marginRight: '1px' }} />
            <span style={{ marginRight: '10px' }}>
              {translation(translationCache, 'Download')}{' '}
            </span>
          </a>
        </Button>
        <Button type='primary' style={{ marginRight: '10px' }}>
          <Upload
            multiple={false}
            style={{ marginRight: '10px', color: 'white' }}
            onChange={(info) => {
              if (info.file.status === 'done') {
                message.success(info.file.response.message);
                getFileDownloadName();
                _getList();
              } else if (info.file.status === 'error') {
                message.error(info.file.response.message);
              }
            }}
            action={`${API_RUBUSMASTERS.Upload_Attributes}?SiteId=${siteId}&DeviceTypeAlias=${path[1]}`}
            headers={{
              Authorization: Authorization
            }}
            showUploadList={false}
          >
            <UploadOutlined style={{ marginRight: '1px' }} />
            <span style={{ marginRight: '10px' }}>
              {translation(translationCache, 'Upload')}{' '}
            </span>
          </Upload>
        </Button>
        <Button type='primary' onClick={OpenDrawer}>
          <PlusOutlined /> {translation(translationCache, 'Add Attributes')}
        </Button>
      </div>

      <Tabs theme={themeSettings}>
        <TabPane>
          <StyledTable size="small"
            columns={finalColumns}
            dataSource={list}
            pagination={
              list.length > 10
                ? {
                  pageSize: '10'
                }
                : false
            }
          />
        </TabPane>
      </Tabs>

      <Drawer
        title={
          formObject && formObject.Id
            ? translation(translationCache, 'Update Attributes')
            : translation(translationCache, 'Add Attributes')
        }
        placement="right"
        width={800}
        closable
        onClose={onClose}
        open={visibleParent}
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          theme={themeSettings}
          layout="horizontal"
          ref={hForm}
          name="Site_form"
          initialValues={formObject}
          onFinish={onFinish}
        >
          <Form.Item
            label={translation(translationCache, 'Code')}
            name="Code"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Code !') }]}
          >
            <Input
              disabled={formObject && formObject.Id ? true : false}
              placeholder={translation(translationCache, 'Please enter Code')}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Name')}
            name="Name"
            rules={[{ required: true, message: translation(translationCache, 'Please select Name !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Name')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Mandatory')}
            name="mandatory"
            rules={[{ required: true, message: translation(translationCache, 'Please enter mandatory') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter mandatory')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Widget')}
            name="widget"
            rules={[{ required: true, message: translation(translationCache, 'Please enter widget') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter widget')} />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, 'Is Editable OnUpdate')}
            name="isEditableOnUpdate"
            rules={[{ required: true, message: translation(translationCache, 'Please enter isEditableOnUpdate') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter isEditableOnUpdate')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'API')}
            name="API"
          // rules={[{ required: true, message: translation(translationCache,'Please enter API') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter API')} />
          </Form.Item>
          <DrawerFooter>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              {translation(translationCache, 'Cancel')}
            </Button>
            <Button type="primary" htmlType="submit">
              {translation(translationCache, 'Submit')}
            </Button>
          </DrawerFooter>
        </Form>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Attributes);
